import { useEffect } from 'react'

import { createPortal } from 'react-dom'


import { LiveStreamCreator } from 'features/LiveStream/LiveStreamCreator/LiveStreamCreator'

export const Live = () => {
  const portal = document.getElementById('portal')

  useEffect(() => {
    if (!portal) return

    portal.classList.add('portal--open')

    return () => {
      portal.classList.remove('portal--open')
    }
  }, [portal])

  if (!portal) return null

  return createPortal(<LiveStreamCreator />, portal)
}